<template>
  <div class="sus-container">
    <h1 class="main-title">
      <span>
        {{ $t("integrityManagement.title") }}
        <hr/>
      </span>
    </h1>
    <div class="column-logo column-logo-first">
      <img :src="mptList[$i18n.locale].integrityUrl"/>
    </div>
    <div class="box">
      <div class="box-row">
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].title1 }}</span></h2>
          <div class="content">{{ mptList[$i18n.locale].text1first }}</div>
          <div class="content">{{ mptList[$i18n.locale].text1second }}</div>
          <div class="content" v-if="$i18n.locale!='EN'">{{ mptList[$i18n.locale].text1third }}</div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].title2 }}</span></h2>
          <div class="column-logo">
            <img :src="mptList[$i18n.locale].integrity1Url"/>
          </div>
          <div class="content">{{ mptList[$i18n.locale].text2first }}</div>
          <div class="content">
            {{ mptList[$i18n.locale].text2second }}
            <a :href="mptList[$i18n.locale].pageUrl" :download="mptList[$i18n.locale].pageName">{{mptList[$i18n.locale].text211}}</a> 
            {{mptList[$i18n.locale].text212}}
          </div>
          <div v-if="$i18n.locale=='EN'">
            <div class="content" >{{ mptList[$i18n.locale].text2third }}</div>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2fourth }}</p>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2fifth }}</p>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2sixth }}</p>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2seventh }}</p>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2eighth }}</p>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2ninth }}</p>
            <p>•&nbsp;{{ mptList[$i18n.locale].text2tenth }}</p>
          </div>
          <div class="button-box" v-if="$i18n.locale!='EN'">
            <a href="https://tw.getacgroup.com/upload/download_files/bd9f3078f2abd2d3a5cb9f20cc8fbba2.pdf" class="button-a" target="_blank">{{ mptList[$i18n.locale].btn1}}→</a>
          </div>
        </div>
        <div class="content-box">
          <h2><span>{{ mptList[$i18n.locale].title3 }}</span></h2>
          <div class="content">{{ mptList[$i18n.locale].text3first }}</div>
          <div class="content">{{ mptList[$i18n.locale].text3second }}</div>
          <div class="content" v-if="$i18n.locale=='EN'">{{ mptList[$i18n.locale].text1third }}</div>
          <div class="button-box" v-if="$i18n.locale!='EN'">
            <a :href="mptList[$i18n.locale].pageMPTZ" class="button-a" target="_blank" :download="mptList[$i18n.locale].mptzName">MPTK/Z:《{{ mptList[$i18n.locale].btn2}}》→</a>
          </div>
          <div class="button-box" v-if="$i18n.locale!='EN'">
            <a :href="mptList[$i18n.locale].pageMPTV" class="button-a" target="_blank" :download="mptList[$i18n.locale].mptvName">MPTV:《{{ mptList[$i18n.locale].btn3}}》→</a>
          </div>
          <div class="content">{{ mptList[$i18n.locale].text3third }}</div>
          <div class="content">{{ mptList[$i18n.locale].text3fourth }}</div>
          <div class="content">{{ mptList[$i18n.locale].text3fifth }}</div>
          <div class="content">{{ mptList[$i18n.locale].text3sixth }}</div>
          <div class="content">{{ mptList[$i18n.locale].text3seven }}：0512-57367777</div>
        </div>
        <div>
          <h2><span>{{ mptList[$i18n.locale].title4 }}</span></h2>
          <div class="content">{{ mptList[$i18n.locale].text4first }}</div>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4second }}</p>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4third }}</p>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4fourth }}</p>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4fifth }}</p>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4sixth }}</p>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4seventh }}</p>
          <p>•&nbsp;{{ mptList[$i18n.locale].text4eighth }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mptList: {
        EN: {
          integrityUrl:require('../../assets/integrity/integrity_en.png'),
          integrity1Url:require('../../assets/integrity/integrity1_en.png'),
          pageUrl:"../../static/pdf/page42.pdf",
          pageName:"2021年永續報告書第42頁-英文&日文",
          pageMPTZ:"../../static/pdf/pageMPTZ.pdf",
          mptzName:"檢舉貪污瀆職作業規範-MPTK&Z",
          pageMPTV:"../../static/pdf/pageMPTV.pdf",
          mptvName:"檢舉貪污瀆職規範-MPTV",
          btn1:"反汚職と賄賂と反マネーロンダリング教育",
          btn2:"檢舉貪污瀆職作業規範",
          btn3:"檢舉貪污瀆職規範",
          title1: "A Corporate Culture of Honesty and Integrity",
          text1first: "The corporate culture of honesty and integrity is a foundation for a company’s sustainable management. In compliance with relevant laws and regulations, MPT Solution has established good corporate governance and risk management mechanisms, advocated the corporate culture of integrity and honesty, and requested the employees to properly implement the culture in the internal management and commercial activities, preventing any behaviors against the codes of business ethics and creating a business environment for sustainable development.",
          text1second: "In addition to creating a sincere and honest corporate culture, MPT Solution complies with external laws and regulations and establishes internal systems to ensure that MPT Solution employees operate by the highest level of ethical standards. The company strictly prohibits employees from making illegal political donations in exchange for commercial gains or business advantages. As for laws and regulations, MPT Solution complies with the Corporate Governance Best Practice Principles to be a law-abiding corporate citizen. The company formulated the Ethical Management Best Practice Principles and the Code of Ethical Conduct for Directors and Supervisors to act as the business ethics and ethical management standards, and requires all directors, supervisors, and employees to abide by these standards.",
          text1third: "For the whistleblower reports, statements for the police or other relevant data, the audit unit shall keep them as a secret and retain them separately. Those who disclose the said materials for no reason will be punished according to the Company’s reward and punishment regulations. In addition, MPT Solution shall guarantee the whistleblowers’ safety. Those who threaten, intimidate or perform illegal actions to the whistleblowers shall be severely punished as per the laws and regulations.",
          title2: "Anti-Corruption And Human Rights Education : 100% Training Rate",
          text2first: "In order to implement the education of integrity and strengthen the international anti-corruption trend promotion, MPT Solution incorporated anti-corruption and human rights education into employee compulsory training , and compiled unified teaching materials, covered the following:",
          text2second: "The anti-corruption course adopts rolling training. In addition to the new employees who are compulsory for study, all employees are targeted for retraining every year, for employees to bear in mind the importance of human rights and anti-corruption.",
          text2third:"In 2021, a total of 7,783people from MPT Solution received anti-corruption and human rights education and training, and the training ratio reached 100%. Please refer to ",
          text2fourth:"The introduction of the United Nations Convention Against Corruption.",
          text2fifth:"Corporate Governance Best Practice Principles.",
          text2sixth:"Codes of Ethical Conduct for Employees.",
          text2seventh:"Confidentiality of Material Information and Prohibition of Insider Trading.",
          text2eighth:"Codes of Conduct for Cooperation with Suppliers.",
          text2ninth:"Regulations for Reward and Punishment of Reporting Corruption and Malpractice.",
          text2tenth:"Introduced the Human Rights Protection of Employees in the Chapters on Labor Human Rights, including law compliance working-hour and non-forced labor, prohibiting child labor, gender work equality, and eliminating sexual harassment.",
          text211:"page 42 of this report for the training details of each subsidiary",
          text212:". We did not find or receive any internal or external reports of unethical conducts by all operational sites in 2021, as disclosed in this report.",
          title3: "Whistleblowing System",
          text3first: "In order to prevent relevant illegal situations and maintain the normal operation of the company, MPT Solution has formulated Guidelines Governing the Reporting of Corruption and Malpractices and Whistleblowing System. The audit unit shall set up a special investigation committee to investigate within three days after receiving the report of unethical conduct. The committee is composed of legal affairs, audit, and HR representatives as well as direct supervisors of involved employees with the audit unit serving as the convener. If the report is verified to be true, in addition to ordering the relevant units to make improvements within a time limit, punish the dereliction of duty in accordance with the law, and prosecute the liability for damages in accordance with the law, so as to set an example.",
          text3second: "MPT Solution has established a mailbox for reporting violations of the Ethical Management Best Practice Principles for internal and external personnel to respond to opinions or report violations, and include the reporting mailbox in the supplier contract. The informant is given a maximum reporting reward of NT$200,000 or 5% of the loss amount according to the guidelines. ",
          text3third: "Irregular Business Conduct Reporting Contact",
          text3fourth: "Ms. He, Director of the Audit Department",
          text3fifth: "MPTK/Z Mailbox: MPTKAudit@mpt-solution.com.cn",
          text3sixth: "MPTV Mailbox: VNAudit@mpt-solution.com.cn",
          text3seven:"Telephone",
          title4: "Regulatory Compliance",
          text4first: "MPT Solution strictly abides by regulatory laws relating to corporate governance and integrity management, environmental protection, and labor human rights to implement civic and law-related education within the organization. There were no incidents of the following violations in 2021:",
          text4second: "Major penalties for environmental protection and related disputes.",
          text4third: "Significant penalties or non-monetary sanction due to the legal violation.",
          text4fourth: "Product or service in violation of consumer health and safety laws and principles.",
          text4fifth: "Product or service in violation of information or labeling laws and principles.",
          text4sixth: "Significant fines for violating the relevant laws and decrees related to provide or use the products or services.",
          text4seventh: "Marketing activities (including advertising, promotion, and sponsorships) in violation of relevant laws and principles.",
          text4eighth: "Violation of anti-competitive behaviors, anti-trust and anti-monopoly laws and regulations.",
        },
        CN: {
          integrityUrl:require('../../assets/integrity/integrity_zh.png'),
          integrity1Url:require('../../assets/integrity/integrity1_zh.png'),
          pageUrl:"../../static/pdf/page41.pdf",
          pageName:"2021年永續報告書第41頁-中文",
          pageMPTZ:"../../static/pdf/pageMPTZ.pdf",
          mptzName:"檢舉貪污瀆職作業規範-MPTK&Z",
          pageMPTV:"../../static/pdf/pageMPTV.pdf",
          mptvName:"檢舉貪污瀆職規範-MPTV",
          btn1:"反贪腐暨洗钱防制倡导课程",
          btn2:"检举贪污渎职作业规范",
          btn3:"检举贪污渎职规范",
          title1: "诚实正直的企业文化",
          text1first: "廉洁诚信的企业文化是公司永续经营的基础，MPT Solution依循相关法令规范，制定廉洁良好之公司治理与风险控管机制，倡导诚信正直的企业文化。要求员工于内部管理及商业活动中确实执行，杜绝违反从业道德之行为，创造永续发展之经营环境。透过遵循外部法规与建立内部制度，规范所有神基成员以最高道德标准从事商业行为，严禁提供非法的政治献金谋取商业利益或交易优势。从法规面，遵循神基投资控股股份有限公司《公司治理实务守则》，做奉公守法的企业公民。订定《诚信经营守则》及董监事《道德行为准则》，以做为企业道德与诚信经营之绳墨，要求董监事与全体同仁奉守贯彻。",
          text1second: "MPT Solution透过内控、内稽制度进行监督、查核贪腐事件，透过风险评估鉴别出的重大贪腐风险包括违反营业秘密、侵占公款、盗卖公司财产、收取回扣或不当利益。因此对内员工雇佣合同、员工行为准则亦明文禁止贪污盗窃、滥用职权、行贿受贿、营私舞弊等违背职业道德或损害公司利益之行为，并要求相关人员于特定项目中签署保密协议。触犯上述不法行为者，经查证属实，公司将依照《员工奖惩办法》办理。情节重大者，本公司得不须预告终止劳动契约。若涉及刑责则移送法办，并追诉相关损失赔偿责任。",
          text1third: "外部治理方面，凡与MPT Solution交易金额逾八万元新台币以上之厂商，皆必须签署签署最惠价及清廉保证协议，无签署该合约之厂商，系统将自动禁止进行付款程序，防堵漏洞发生。与厂商签属之合约同时提供举报专线信息，由MPT Solution稽核部负责受理从业道德相关之申诉与检举事件。",
          title2: "反贪腐与人权教育训练",
          text2first: "为落实诚信教育，加强国际反贪腐趋势倡导，MPT Solution将反贪腐与人权教育纳入员工必修训练，编制统一教材，涵盖联合国反贪腐条约介绍、公司治理实务守则、员工道德行为准则、重大信息保密及禁止内线交易、与供货商合作行为准则、检举贪污渎职之奖惩办法。在劳动人权篇章，介绍员工人权保障，包括工时合法及不强迫劳动、禁雇童工、性别工作平等以及杜绝性骚扰等。",
          text2second: "反贪腐课程采取滚动式训练，除了新到职者于新人训练必修外，每年也针对所有员工重新训务使员工铭记人权与反贪腐之重要性。2021年MPT Solution合计有7,783人次接受反贪腐与人权教育训练，受训比例达100%，各子公司受训情形详见", 
          text211:"2021年永续报告书第41页",
          text212:"。2021年本MPT Solution内、外部皆未查获或接获任何违反从业道德相关之检举事件。",
          title3: "吹哨者制度",
          text3first: "为防范相关不法情事，维护公司正常运作，MPT Solution《检举贪污渎职办法》，明定完善的吹哨者检举制度。稽核单位收到检举书后三日内成立项目调查委员会进行调查。委员会由稽核单位召集法务、稽核、人事代表及涉案人之中心主管组成。若经查证属实，除责令相关单位限期改善外，针对失职人员依法惩处，并依法追诉损失赔偿责任，以儆效尤。",
          text3second: "MPT Solution建立检举违反诚信与道德行为准则之信箱供内外部人员反应意见或检举违规事件，并将检举信箱详载于供货商合约当中。检举人依规定给予20万元新台币或损失金额之5%做为破案奖金。稽核单位对于检举书、笔录或其他相关数据，应予保密，另行保存。无故泄漏者，依公司奖惩办法惩处。且检举人之安全，公司应予以保护，对检举人威胁、恐吓或其他不法行为者，应依法严惩。",
          text3third: "从业道德检举信箱",
          text3fourth: "稽核处主管何小姐",
          text3fifth: "MPTK/Z信箱: MPTKAudit@mpt-solution.com.cn",
          text3sixth: "MPTV信箱: VNAudit@mpt-solution.com.cn",
          text3seven:"电话",
          title4: "法规遵循",
          text4first: "MPT Solution严格恪守主管机关公司治理与诚信经营、环境保护及劳工人权等相关法令，落实组织内之法规教育。2021年并未发生下列违反法规之重大情事:",
          text4second: "环境保护之重大裁罚与相关争议",
          text4third: "违反法令而受到重大金额裁罚或非金钱性制裁",
          text4fourth: "产品或服务违反消费者健康安全法令与守则",
          text4fifth: "产品或服务违反信息或卷标相关法令与守则",
          text4sixth: "因违反相关提供或使用产品或服务之法令而受有重大罚款",
          text4seventh: "营销活动（包括广告、推销与赞助）相关法令与守则之重大违反",
          text4eighth: "反竞争行为、反托拉斯与垄断等相关法令",
        },
        CHT: {
          integrityUrl:require('../../assets/integrity/integrity_zht.png'),
          integrity1Url:require('../../assets/integrity/integrity1_zht.png'),
          pageUrl:"../../static/pdf/page41.pdf",
          pageName:"2021年永續報告書第41頁-中文",
          pageMPTZ:"../../static/pdf/pageMPTZ.pdf",
          mptzName:"檢舉貪污瀆職作業規範-MPTK&Z",
          pageMPTV:"../../static/pdf/pageMPTV.pdf",
          mptvName:"檢舉貪污瀆職規範-MPTV",
          btn1:"反贪腐暨洗钱防制倡导课程",
          btn2:"检举贪污渎职作业规范",
          btn3:"检举贪污渎职规范",
          title1: "誠實正直的企業文化",
          text1first: "廉潔誠信的企業文化是公司永續經營的基礎，MPT Solution依循相關法令規範，制定廉潔良好之公司治理與風險控管機制，倡導誠信正直的企業文化。要求員工於內部管理及商業活動中確實執行，杜絕違反從業道德之行為，創造永續發展之經營環境。透過遵循外部法規與建立內部制度，規範所有神基成員以最高道德標準從事商業行為，嚴禁提供非法的政治獻金謀取商業利益或交易優勢。從法規面，遵循神基投資控股股份有限公司《公司治理實務守則》，做奉公守法的企業公民。訂定《誠信經營守則》及董監事《道德行為準則》，以做為企業道德與誠信經營之繩墨，要求董監事與全體同仁奉守貫徹。",
          text1second: "MPT Solution透過內控、內稽制度進行監督、查核貪腐事件，透過風險評估鑑別出的重大貪腐風險包括違反營業秘密、侵占公款、盜賣公司財產、收取回扣或不當利益。因此對內員工雇傭合同、員工行為準則亦明文禁止貪污盜竊、濫用職權、行賄受賄、營私舞弊等違背職業道德或損害公司利益之行為，並要求相關人員於特定專案中簽署保密協議。觸犯上述不法行為者，經查證屬實，公司將依照《員工獎懲辦法》辦理。情節重大者，本公司得不須預告終止勞動契約。若涉及刑責則移送法辦，並追訴相關損失賠償責任。",
          text1third: "外部治理方面，凡與MPT Solution交易金額逾八萬元新台幣以上之廠商，皆必須簽署簽署最惠價及清廉保證協議，無簽署該合約之廠商，系統將自動禁止進行付款程序，防堵漏洞發生。與廠商簽屬之合約同時提供舉報專線資訊，由MPT Solution稽核部負責受理從業道德相關之申訴與檢舉事件。",
          title2: "反貪腐與人權教育訓練",
          text2first: "為落實誠信教育，加強國際反貪腐趨勢宣導，MPT Solution將反貪腐與人權教育納入員工必修訓練，編制統一教材，涵蓋聯合國反貪腐條約介紹、公司治理實務守則、員工道德行為準則、重大資訊保密及禁止內線交易、與供應商合作行為準則、檢舉貪污瀆職之獎懲辦法。在勞動人權篇章，介紹員工人權保障，包括工時合法及不強迫勞動、禁雇童工、性別工作平等以及杜絕性騷擾等。",
          text2second: "反貪腐課程採取滾動式訓練，除了新到職者於新人訓練必修外，每年也針對所有員工重新訓務使員工銘記人權與反貪腐之重要性。2021年MPT Solution合計有7,783人次接受反貪腐與人權教育訓練，受訓比例達100%，各子公司受訓情形詳見",
          text211:"2021年永續報告書第41頁",
          text212:"。2021年本MPT Solution內、外部皆未查獲或接獲任何違反從業道德相關之檢舉事件。",
          title3: "吹哨者制度",
          text3first: "為防範相關不法情事，維護公司正常運作，MPT Solution《檢舉貪污瀆職辦法》，明定完善的吹哨者檢舉制度。稽核單位收到檢舉書後三日內成立專案調查委員會進行調查。委員會由稽核單位召集法務、稽核、人事代表及涉案人之中心主管組成。若經查證屬實，除責令相關單位限期改善外，針對失職人員依法懲處，並依法追訴損失賠償責任，以儆效尤。",
          text3second: "MPT Solution建立檢舉違反誠信與道德行為準則之信箱供內外部人員反應意見或檢舉違規事件，並將檢舉信箱詳載於供應商合約當中。檢舉人依規定給予20萬元新台幣或損失金額之5%做為破案獎金。稽核單位對於檢舉書、筆錄或其他相關資料，應予保密，另行保存。無故洩漏者，依公司獎懲辦法懲處。且檢舉人之安全，公司應予以保護，對檢舉人威脅、恐嚇或其他不法行為者，應依法嚴懲。",
          text3third: "從業道德檢舉信箱",
          text3fourth: "稽核處主管何小姐",
          text3fifth: "MPTK/Z 信箱: MPTKAudit@mpt-solution.com.cn",
          text3sixth: "MPTV 信箱: VNAudit@mpt-solution.com.cn",
          text3seven:"電話",
          title4: "法規遵循",
          text4first: "MPT Solution嚴格恪守主管機關公司治理與誠信經營、環境保護及勞工人權等相關法令，落實組織內之法規教育。2021年並未發生下列違反法規之重大情事:",
          text4second: "環境保護之重大裁罰與相關爭議",
          text4third: "違反法令而受到重大金額裁罰或非金錢性制裁",
          text4fourth: "產品或服務違反消費者健康安全法令與守則",
          text4fifth: "產品或服務違反資訊或標籤相關法令與守則",
          text4sixth: "因違反相關提供或使用產品或服務之法令而受有重大罰鍰",
          text4seventh: "行銷活動（包括廣告、推銷與贊助）相關法令與守則之重大違反",
          text4eighth: "反競爭行為、反托拉斯與壟斷等相關法令",
        },
        JP: {
          integrityUrl:require('../../assets/integrity/integrity_jp.png'),
          integrity1Url:require('../../assets/integrity/integrity1_jp.png'),
          pageUrl:"../../static/pdf/page42.pdf",
          pageName:"2021年永續報告書第42頁-英文&日文",
          pageMPTZ:"../../static/pdf/pageMPTZ.pdf",
          mptzName:"檢舉貪污瀆職作業規範-MPTK&Z",
          pageMPTV:"../../static/pdf/pageMPTV.pdf",
          mptvName:"檢舉貪污瀆職規範-MPTV",
          btn1:"反汚職と賄賂と反マネーロンダリング教育",
          btn2:"檢舉貪污瀆職作業規範",
          btn3:"檢舉貪污瀆職規範",
          title1: "誠実な企業文化",
          text1first: "清廉で誠実な企業文化は会社経営の基礎です。MPT Solutionは法令・規則を遵守し、清廉で誠実な会社管理政策を制定しており、違反行為を厳しく取り締まっています。全社員は本社GETACの「公司治理实务守则」を遵守すると要求されます。｢誠信經營守則｣｢道德行為準則｣を制定しており、取締役メンバーを始め全社員を規制します。",
          text1second: "MPT Solution内部では監察政策によって、法令・倫理に反するような接待・贈答と贈賄行為など監督と監察をします。社員の労働契約には重大汚職と贈賄（情報を漏らしたり、公金を横領したり、不当な利益を与えたり、得たりすることなど）が禁止されると書いてあります。違法行為が発生する場合には、｢員工獎懲辦法｣によって処罰します。刑事責任も追跡します。",
          text1third: "外部管理：MPT Solutionと取引金額は八萬TWD以上のベンダーは最特恵価額を提供し、清廉保証契約をサインします。もし契約をしないと、送金システムは送金停止となります。契約すると同時に通報の連絡先もベンダーに伝えます。MPT Solution監察部門は通報情報を受けてから、処理します。",
          title2: "反汚職と人権教育",
          text2first: "誠実と反汚職と賄賂を教育するために、反汚職と賄賂と人権教育はMPT Solution入社教育の一科として、社員を教育します。テキストには国連反汚職と賄賂規制の紹介、処分事例、社員の行為基準、情報セキュリティのルール守るルール、インサイダー取引の禁止、ベンダーとの取引の規制、通報方法と奨励＆罰金などが書いてあります。労働員の人権尊重紹介には、工数合理的で、強制労働と少年労働者と差別とハラスメントを許容しないと詳しく説明します。",
          text2second: "新入社員の他に、全社員も反汚職と賄賂教育を受けます。2021年にMPT Solutionは合計7,783人が教育授業を受けました。受け率は100%です。各支社教育詳細情報は",
          text211:"｢2021年永續報告書｣の42ページに載せます",
          text212:"。2021年にMPT Solutionは違法通報を受けませんでした。",
          title3: "Whistleblower制度",
          text3first: "違法行為発生しないように、MPT Solution｢檢舉貪污瀆職辦法｣にはWhistleblower制度を規制しました。監査部門は通報を受けた三日間内に、調査委員会を成立し、事実を調査します。委員会は法務、監察と通報された社員の部門担当者を含めています。もし違法行為は事実であれば、関連部門を期限内で改善すると要求した上で、違法社員に対し厳しく取り締まって、訴訟を起こして、賠償金も請求します。",
          text3second: "MPT Solutionは社内外共用の告発メールがあって、ベンダーの契約にもメールアドレスを載せます。告発人は20万元TWNあるいは告発された事件の価値の5%の奨励金をもらえます。監察部門は告発に関連資料をセキュリティ管理します。情報漏れると会社規制によって、罰を与えます。告発人の安全性を会社から保障すべきです。MPT Solutionは特定しようとする行為やこの者に対する嫌がらせ等の報復行為から守ります。",
          text3third: "通報メールアドレス",
          text3fourth: "監査所主管何さん",
          text3fifth: "MPTK/Z メールボックス: MPTKAudit@mpt-solution.com.cn",
          text3sixth: "MPTV メールボックス: VNAudit@mpt-solution.com.cn",
          text3seven:"電話",
          title4: "法律の遵守",
          text4first: "MPT Solutionは誠実経営と環境保護及び労働者人権保護法律を厳正に遵守します。確実に社員教育をやります。2021年に下記違法事件がないのです:",
          text4second: "環境保護に関連する重大の処罰と係争",
          text4third: "違法行為で高金額の罰金あるいはお金なしの処罰",
          text4fourth: "製品とサービスは消費者の健康と安全性法令に違法する",
          text4fifth: "製品とサービスは情報あるいは標識関連法令に違法する",
          text4sixth: "製品とサービスは関連法令に違法して、重大処罰を受ける",
          text4seventh: "マーケティング活動（コマーシャルとスポンサー）は関連法令違法",
          text4eighth: "反競争、反トラスト関連法令の違反",
        },
      },
    };
  }
};
</script>

<style scoped>
.column-logo img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: auto;
  width: 80rem;
}
.box{
  width: 100%;
  max-width: 80rem;
  margin: 4rem auto;
}
.box-row{
  text-align: left;
  color:#00457A;
}
.content-box{
  padding-bottom: 3rem;
  border-bottom: 2px solid #f3f3f3;
}
.box-row h2{
  padding: 1rem 0;
  color:#00457A;
  text-align: left;
  min-width: 20rem;
}
.box-row h2 span{
  border-bottom: 0.2rem solid #29aae1;
}
.box-row .content{
  text-align: left;
  color:#0B1C36;
  padding-bottom: 1rem;
  font-size: 1.4rem;
}
.box-row p{
  text-align: left;
  color:#0B1C36;
  padding: 1rem 0rem;
  text-indent: 2rem;
}
.button-box{
  text-align: right;
}
.button-a{
  display: inline-block;
  margin: 3px;
  white-space: nowrap;
  line-height: 1;
  border: none;
  padding: 1rem 2rem;
  letter-spacing: 2px;
  text-decoration: none;
  font-size: 1.5rem;
  border-radius: 0.5rem;
  color: #fff;
  background: #29aae1;
}
.button-a:hover{
  background: #D74B00
}
.mailbox{
  display: flex;
}
.mailbox-text{
  line-height: 4.8rem;
  font-weight: bold;
}
@media (max-width: 767px) {
  .column-logo-first img{
    max-width: 100%;
    height: auto;
    display: block;
    margin: auto;
    width: 80rem;
    padding: 0 0.5rem;
  }
  .column-logo img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: auto;
    width: 80rem;
  }
  .box{
    width: 100%;
    max-width: 80rem;
    margin: 1rem auto;
    padding: 0 0.5rem;
  }
  .box-row{
    text-align: left;
    color:#00457A;
  }
  .content-box{
    padding-bottom: 2rem;
    border-bottom: 2px solid #f3f3f3;
  }
  .box-row h2{
    padding: 1rem 0;
    color:#00457A;
    text-align: left;
  }
  .box-row h2 span{
    border-bottom: 0.1rem solid #29aae1;
  }
  .box-row .content{
    text-align: left;
    color:#0B1C36;
    padding-bottom: 1rem;
    font-size: 0.8rem;
  }
  .mailbox-text{
    line-height: 3.6rem;
    font-weight: bold;
  }
  .box-row p{
    text-align: left;
    color:#0B1C36;
    padding: 0.5rem 0rem;
    text-indent: 1rem;
  }
  .button-box{
    text-align: right;
  }
  .button-a{
    display: inline-block;
    margin: 3px;
    white-space: nowrap;
    line-height: 1;
    border: none;
    padding: 1rem 2rem;
    letter-spacing: 2px;
    text-decoration: none;
    font-size: 0.5rem;
    border-radius: 0.5rem;
    color: #fff;
    background: #29aae1;
  }
  .button-a:hover{
    background: #D74B00
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Company/EthicalManagement.vue